import {
  CircleAlertIcon,
  CircleCheckIcon,
  InfoIcon,
  type LucideIcon,
  TriangleAlertIcon,
} from "lucide-react";
import type { NotificationType } from "@/types/INotification";
import S from "./styles.module.scss";

const TYPE_ICON: Record<NotificationType, LucideIcon> = {
  info: InfoIcon,
  success: CircleCheckIcon,
  warning: TriangleAlertIcon,
  danger: CircleAlertIcon,
};

interface NotificationTypeIconProps {
  type: NotificationType;
  muted?: boolean;
  size?: "sm" | "md";
}

const NotificationTypeIcon = ({
  type,
  muted = false,
  size = "sm",
}: NotificationTypeIconProps) => {
  const Icon = TYPE_ICON[type] ?? InfoIcon;
  return (
    <span
      className={`${S.icon} ${S[size]} ${muted ? S.muted : S[type] ?? ""}`}
      aria-hidden="true"
    >
      <Icon size={size === "md" ? 18 : 16} />
    </span>
  );
};

export default NotificationTypeIcon;

